// eslint-disable-next-line no-restricted-imports
import styled, { css } from 'styled-components';

export const FAQItemContainer = styled.div<{ isOpen: boolean }>`
  list-style-type: none;
  padding: 16px 24px;
  width: fit-content;

  ${({ isOpen }) => css`
    border: 1px solid #d1d1e3;
    border-radius: 8px;
    margin-bottom: 10px;
    width: 100%;

    & > button {
      background: transparent;
      border: none;
      color: #312f4f;
      cursor: pointer;
      display: flex;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      justify-content: space-between;
      line-height: 150%;
      text-align: left;
      width: 100%;
      align-items: center;

      .chevron {
        transition: all 300ms ease-in-out;

        ${isOpen
          ? css`
              rotate: 180deg;
            `
          : css`
              rotate: 0;
            `}
      }
    }

    & > span {
      color: #312f4f;
      display: block;
      font-size: 16px;
      line-height: 150%;
      max-height: 0;
      overflow: hidden;
      transition: all 200ms ease-in-out;
    }
  `};
`;
